import { useState, useEffect } from "react";
import {
  Pagination,
  Popconfirm,
  Spin,
  message,
  Card,
  Row,
  Col,
  Empty,
} from "antd";
import { Link, useNavigate } from "react-router-dom";
import { DeleteFilled, EditOutlined } from "@ant-design/icons";
import { get, del } from "../../services";

const { Meta } = Card;

const Blogstable = () => {
  const navigate = useNavigate();
  const [adminData, setAdmindata] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loader, setLoader] = useState(true);
  const [selectedRecord, setSelectedRecord] = useState(false);
  const limit = 10;

  // Method for API call
  const getAllAdmins = (currentPage) => {
    setLoader(true);
    get(`/blogs?page=${currentPage}&limit=${limit}`)
      .then((response) => {
        console.log(response?.data);
        setAdmindata(response?.data);
        setLoader(false);
      })
      .catch((err) => {
        setLoader(false);
      });
  };

  useEffect(() => {
    getAllAdmins(currentPage);
    // eslint-disable-next-line
  }, []);

  // confirm handler
  const confirm = (data) => {
    setSelectedRecord(data?._id);
    // API call to delete selected record
    del(`/blogs/${data?._id}`)
      .then(() => {
        // to delete locally from our frontend lists
        const remaingRecords = adminData?.blogs?.filter(
          (item) => item?._id !== data?._id
        );
        setAdmindata({ ...adminData, blogs: remaingRecords });
        // success message
        message.success("Record deleted Successfully");
        setSelectedRecord(false);
      })
      .catch(() => {
        message.error("Error");
        setSelectedRecord(false);
      });
  };

  // Cancel
  const cancel = (e) => {
    console.log(e);
  };

  return (
    <div>
      <div className="header4">
        <h3>News & Blogs</h3>{" "}
        <div className="events-button">
          <Link to="/add-blog">
            <button className="cursor-pointer add-event">
              Add News & Blog
            </button>
          </Link>
        </div>
      </div>
      {/* Card */}
      {loader ? (
        <div className="two-color-loader">
          <div className="spinner"></div>
        </div>
      ) : adminData?.blogs?.length > 0 ? (
        <div>
          <div>
            <Row gutter={24} scroll={{ x: 1023 }}>
              {adminData?.blogs?.map((item, index) => (
                <Col xs={24} sm={24} md={12} lg={12} xl={8} xxl={6} key={index}>
                  <Card
                    hoverable
                    style={{
                      boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
                      margin: "15px 0px",
                    }}
                    cover={
                      <img
                        alt="blog"
                        src={item?.images[0]?.url}
                        className="card-img-height"
                      />
                    }
                    actions={[
                      <EditOutlined
                        key="edit"
                        onClick={() => navigate("/edit-blog/" + item._id)}
                        className="delete-icon-admin "
                      />,
                      item?._id === selectedRecord ? (
                        <Spin />
                      ) : (
                        <Popconfirm
                          title="Delete the task"
                          description="Are you sure to delete this task?"
                          onConfirm={() => confirm(item)}
                          onCancel={cancel}
                          okText="Yes"
                          cancelText="No"
                        >
                          <DeleteFilled className="cursor-pointer delete-icon-admin" />
                        </Popconfirm>
                      ),
                    ]}
                  >
                    <Meta
                      title={item?.title}
                      description={
                        <div
                          className="truncate-description"
                          dangerouslySetInnerHTML={{
                            __html:
                              item?.description !== "null"
                                ? item?.description
                                : "",
                          }}
                        />
                      }
                    />
                  </Card>
                </Col>
              ))}
            </Row>
          </div>
          <Pagination
            defaultCurrent={currentPage}
            total={adminData?.totalBlogs}
            pageSize={limit}
            onChange={(e) => {
              setCurrentPage(e);
              getAllAdmins(e);
            }}
            className="pagination"
          />
        </div>
      ) : (
        <div className="no-data">
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            className="spin-center2"
          />
        </div>
      )}
    </div>
  );
};
export default Blogstable;
